/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, BrowserCacheLocation } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

interface AuthConfig {
  clientId: string;
  authority: string;
  redirectUri: string;
  knownAuthorities?: string[];
}

interface CacheConfig {
  cacheLocation: "localStorage" | "sessionStorage";
  storeAuthStateInCookie: boolean;
}

interface LoggerOptions {
  loggerCallback: (
    level: LogLevel,
    message: string,
    containsPii: boolean,
  ) => void;
}

interface SystemConfig {
  loggerOptions: LoggerOptions;
}

interface MsalConfig {
  auth: AuthConfig;
  cache: CacheConfig;
  system: SystemConfig;
}

export const msalConfig: MsalConfig = {
  auth: {
    clientId: "78dcc99f-5ec2-431f-a715-f64615665efb",
    authority: `https://accounts.ligaportugal.pt/lpfpb2corganization.onmicrosoft.com/B2C_1A_ACCOUNTLINK_SUSI`,
    redirectUri: window.location.origin,
    knownAuthorities: ["accounts.ligaportugal.pt"],
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true, // recomendado para IE11 ou Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid"],
};
